import * as React from "react";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import { useForm } from "react-hook-form";
import ConfirmationModal from "../../../../common/components/ConfirmationModal";
import { Tooltip } from "@mui/material";
import { DeleteIcon, EditIcon } from "../../../../assets/CommonAssets";

export default function POMultipleTable(props) {
  // const { poData, setDataResult } = props;
  const methods = useForm({
    mode: "onChange",
  });
  const { register, watch, setValue, getValues, handleSubmit, control } =
    methods;

  const [openPost, setOpenPost] = React.useState(false);
  const handleClosePost = () => {
    if (openPost) {
      setOpenPost(false);
    }
  };

  const [deleteIndex, setDeleteIndex] = React.useState(null);
  const deleteRecord = () => {
    if (deleteIndex !== null) {
      let newTemplateData = [...props.poMultipleData];
      newTemplateData.splice(deleteIndex, 1);
      props.setPoMultipleData(newTemplateData);
      handleClosePost();
    }
  };

  const handleChangeRate = (Rate, index, row) => {
    if (Number(Rate) > 0) {
      let dataArray = [...props?.poMultipleData];
      console.log(
        "The row in the PO Multiple comp is :",
        row,
        dataArray[index]
      );

      let totalAmount = Number(Rate) * Number(row?.quantity);

      let discountAmt =
        Number(row?.totalAmount / 100) * Number(row?.discPercentage);

      dataArray[index].discAmount = Number(discountAmt);

      let discountedAmt = Number(row?.totalAmount) - Number(discountAmt);

      let gstAmount =
        Number(Number(discountedAmt) * Number(row?.gstPercentage)) / 100;

      dataArray[index].gstAmount = Number(gstAmount);

      let totalAmtMDiscountAmt = Number(totalAmount) - Number(discountAmt);

      dataArray[index].netAmount = totalAmtMDiscountAmt + Number(gstAmount);

      props?.setPoMultipleData(dataArray);
    } else {
      let dataArray = [...props?.poMultipleData];

      let totalAmount = Number(0) * Number(row?.quantity);

      let discountAmt =
        Number(row?.totalAmount / 100) * Number(row?.discPercentage);

      dataArray[index].discAmount = Number(discountAmt);

      let discountedAmt = Number(row?.totalAmount) - Number(discountAmt);

      let gstAmount =
        Number(Number(discountedAmt) * Number(row?.gstPercentage)) / 100;

      dataArray[index].gstAmount = Number(gstAmount);

      let totalAmtMDiscountAmt = Number(totalAmount) - Number(discountAmt);

      dataArray[index].netAmount = totalAmtMDiscountAmt + Number(gstAmount);

      props?.setPoMultipleData(dataArray);
    }
  };

  return (
    <>
      <div className="grid w-auto">
        <Box sx={{ width: "100%", overflow: "hidden" }}>
          <Paper sx={{ width: "100%", my: 1 }}>
            <TableContainer
              sx={{
                "&::-webkit-scrollbar": {
                  width: 7,
                  height: 5,
                },
                "&::-webkit-scrollbar-track": {
                  backgroundColor: "#7393B3",
                },
                "&::-webkit-scrollbar-thumb": {
                  backgroundColor: "#1e3a8a",
                },
              }}
              className="rounded h-[400px]"
            >
              <Table size="small" stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    <TableCell
                      className="whitespace-nowrap"
                      style={{ background: "#F1F1F1" }}
                    >
                      <span className="text-gray-600 font-bold">Action</span>
                    </TableCell>

                    <TableCell
                      className="whitespace-nowrap"
                      style={{ background: "#F1F1F1" }}
                    >
                      <span className="text-gray-600 font-bold">Item Name</span>
                    </TableCell>
                    <TableCell
                      className="whitespace-nowrap"
                      style={{ background: "#F1F1F1" }}
                    >
                      <span className="text-gray-600 font-bold">
                        Supplier Name
                      </span>
                    </TableCell>
                    <TableCell
                      className="whitespace-nowrap"
                      style={{ background: "#F1F1F1" }}
                    >
                      <span className="text-gray-600 font-bold">Quantity</span>
                    </TableCell>
                    <TableCell
                      className="whitespace-nowrap"
                      style={{ background: "#F1F1F1" }}
                    >
                      <span className="text-gray-600 font-bold">Free Qty</span>
                    </TableCell>
                    <TableCell
                      className="whitespace-nowrap"
                      style={{ background: "#F1F1F1" }}
                    >
                      <span className="text-gray-600 font-bold">U.O.M.</span>
                    </TableCell>

                    <TableCell
                      className="whitespace-nowrap"
                      style={{ background: "#F1F1F1" }}
                    >
                      <span className="text-gray-600 font-bold">
                        Rate/Quantity
                      </span>
                    </TableCell>

                    <TableCell
                      className="whitespace-nowrap"
                      style={{ background: "#F1F1F1" }}
                    >
                      <span className="text-gray-600 font-bold">
                        Total Amount
                      </span>
                    </TableCell>

                    <TableCell
                      className="whitespace-nowrap"
                      style={{ background: "#F1F1F1" }}
                    >
                      <span className="text-gray-600 font-bold">Disc. (%)</span>
                    </TableCell>

                    <TableCell
                      className="whitespace-nowrap"
                      style={{ background: "#F1F1F1" }}
                    >
                      <span className="text-gray-600 font-bold">
                        Dics. Amount
                      </span>
                    </TableCell>

                    <TableCell
                      className="whitespace-nowrap"
                      style={{ background: "#F1F1F1" }}
                    >
                      <span className="text-gray-600 font-bold">GST(%)</span>
                    </TableCell>

                    <TableCell
                      className="whitespace-nowrap"
                      style={{ background: "#F1F1F1" }}
                    >
                      <span className="text-gray-600 font-bold">
                        GST Amount
                      </span>
                    </TableCell>

                    <TableCell
                      className="whitespace-nowrap"
                      style={{ background: "#F1F1F1" }}
                    >
                      <span className="text-gray-600 font-bold">
                        Net Amount
                      </span>
                    </TableCell>
                    <TableCell
                      className="whitespace-nowrap"
                      style={{ background: "#F1F1F1" }}
                    >
                      <span className="text-gray-600 font-bold">MRP</span>
                    </TableCell>
                    <TableCell
                      className="whitespace-nowrap"
                      style={{ background: "#F1F1F1" }}
                    >
                      <span className="text-gray-600 font-bold">
                        Specification
                      </span>
                    </TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {props.poMultipleData.map((row, index) => {
                    return (
                      <TableRow key={index}>
                        <TableCell>
                          <div className="flex space-x-1">
                            <Tooltip title="Edit">
                              <button
                                type="button"
                                onClick={() => {
                                  props?.setEditItemRow(row);
                                  props?.setEditItemRowIndex(index);
                                }}
                              >
                                <EditIcon />
                              </button>
                            </Tooltip>
                            <Tooltip title="Delete">
                              <button
                                type="button"
                                onClick={() => {
                                  setOpenPost(true);
                                  setDeleteIndex(index);
                                }}
                              >
                                <DeleteIcon />
                              </button>
                            </Tooltip>
                          </div>
                        </TableCell>

                        <TableCell className="whitespace-nowrap">
                          {row.searchItemCode.label}
                        </TableCell>
                        <TableCell className="whitespace-nowrap">
                          {row.supplier}
                        </TableCell>
                        <TableCell className="whitespace-nowrap">
                          {row.doQty}
                        </TableCell>
                        <TableCell className="whitespace-nowrap">
                          {row.freeQty}
                        </TableCell>
                        <TableCell className="whitespace-nowrap">
                          {row.uom}
                        </TableCell>

                        <TableCell className="whitespace-nowrap">
                          <input
                            style={{
                              outline: "none",
                            }}
                            className="h-6 border border-gray-400  rounded w-24 text-center py-1"
                            defaultValue={row.rate}
                            {...register(`poItemRate${index}`)}
                            onChange={(e) => {
                              if (Number(e.target?.value) > 0) {
                                handleChangeRate(
                                  Number(e.target?.value),
                                  index,
                                  row
                                );
                              } else {
                                handleChangeRate(0, index, row);
                              }
                            }}
                          />
                        </TableCell>

                        <TableCell className="whitespace-nowrap">
                          {row.totalAmount}
                        </TableCell>

                        <TableCell className="whitespace-nowrap">
                          {row.discPercentage}
                        </TableCell>

                        <TableCell className="whitespace-nowrap">
                          {row.discAmount}
                        </TableCell>

                        <TableCell className="whitespace-nowrap">
                          {row.vatPer}
                        </TableCell>

                        <TableCell className="whitespace-nowrap">
                          {row.vatAmt}
                        </TableCell>

                        <TableCell className="whitespace-nowrap">
                          {row.netAmount}
                        </TableCell>
                        <TableCell className="whitespace-nowrap">
                          {row.mrp}
                        </TableCell>
                        <TableCell className="whitespace-nowrap">
                          {row.specification}
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
              {props.poMultipleData.length > 0 ? null : (
                <div className="flex justify-center text-gray-400 font-semibold mt-12">
                  No Items Added
                </div>
              )}
            </TableContainer>
          </Paper>
        </Box>
        <ConfirmationModal
          confirmationOpen={openPost}
          confirmationHandleClose={handleClosePost}
          confirmationSubmitFunc={deleteRecord}
          confirmationLabel="Confirmation"
          confirmationMsg="Are you sure want to delete this item ?"
          confirmationButtonMsg="Delete"
        />
      </div>
    </>
  );
}
